import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { MO_TRAVEL_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { MoTravelListPage } from '@/features/moTravel/pages/MoTravelListPage';
import { moTravelListSearchSchema } from '@/features/moTravel/types/moTravel.types';

export const Route = createFileRoute('/_auth/geo-location/mo-travel-history/')({
  beforeLoad: () => requirePermission(MO_TRAVEL_PERMISSIONS.VIEW),
  validateSearch: moTravelListSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="MO Travel History">
      <Suspense fallback={<PageLoader />}>
        <MoTravelListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
